import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { ShowService } from './../../../services/printos-admin-service/show.service';
import { Component, OnInit, DoCheck } from '@angular/core';

@Component({
  selector: 'app-admin-printos-header',
  templateUrl: './admin-printos-header.component.html',
  styleUrls: ['./admin-printos-header.component.scss']
})
export class AdminPrintosHeaderComponent implements OnInit, DoCheck{
  adminResponse: any;
  activeRoles = []


  constructor(private showService: ShowService,
              private commonService: CommonService,
              private router: Router) { }

  ngOnInit(): void {
  }

  ngDoCheck() {
   
  }

  get currentRole() {
   return this.showService.currentRole;
  }

 get userName() {
   if(this.commonService.userInfo) {
    return this.commonService.userInfo.user.first_name;
   }
 }

  naviagteToHome() {
   this.router.navigate(['/admins/show'])
  }

}
